import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutdpRenbSummary extends Layout {
    sourceRenbill: DataSource;
    textboxRenbId: Textbox;
    textboxRendProcSum: Textbox;
    textboxRendRecsSum: Textbox;
    textboxRendTotalSum: Textbox;
}
